import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css'; // Import the custom CSS file here

const Navbar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const isActive = (path) =>
    location.pathname === path
      ? 'nav-item active-nav'
      : 'nav-item';

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar navbar-expand-lg gov-navbar">
      <div className="container">

        {/* TOGGLER BUTTON (Modified for visibility on blue bg) */}
        <button
          className="navbar-toggler custom-toggler"
          type="button"
          onClick={toggleMenu}
          aria-controls="govNav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* NAV LINKS */}
        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="govNav">
          <ul className="navbar-nav w-100 text-uppercase fw-bold nav-font">

            <li className={isActive('/government')} onClick={closeMenu}>
              <Link className="nav-link" to="/government" >Government</Link>
            </li>

            <li className={isActive('/prime-minister')} onClick={closeMenu}>
              <Link className="nav-link" to="/prime-minister">Prime Minister</Link>
            </li>

            <li className={isActive('/bei')} onClick={closeMenu}>
              <Link className="nav-link" to="/bei">BEI</Link>
            </li>

            <li className={isActive('/media')} onClick={closeMenu}>
              <Link className="nav-link" to="/media">Media</Link>
            </li>

            <li className={isActive('/transparency')} onClick={closeMenu}>
              <Link className="nav-link" to="/transparency">
                Decisional Transparency
              </Link>
            </li>

            <li className={isActive('/meetings')} onClick={closeMenu}>
              <Link className="nav-link" to="/meetings">
                Government Meetings
              </Link>
            </li>

            <li className={isActive('/contacts')} onClick={closeMenu}>
              <Link className="nav-link" to="/contacts">Contacts</Link>
            </li>

            {/* E-VISA */}
            <li className={isActive('/visa-check')} onClick={closeMenu}>
              <Link className="nav-link visa-link" to="/visa-check">
                E-Visa Check
              </Link>
            </li>

            {/* ADMIN */}
            <li className={`${isActive('/admin')} ms-lg-auto`} onClick={closeMenu}>
              <Link className="nav-link admin-link" to="/admin">
                Portal
              </Link>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;